(() => {
  window.addEventListener("abra:popup:shown", () => {
    const abraPopupContent = document.querySelector(
      "abra-popup .abra-popup__text"
    );

    if (abraPopupContent && abraPopupContent.innerText) {
      const decodedContent = decodeHTMLEntities(abraPopupContent.innerText);

      if (/<a\s+href=["'](.*?)["']>(.*?)<\/a>/gi.test(decodedContent)) {
        abraPopupContent.style.visibility = "hidden";

        const safeContent = sanitizeAndRenderLinks(decodedContent);

        abraPopupContent.innerHTML = safeContent;

        abraPopupContent.style.visibility = "visible";
      }
    }
  });

  function decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  function sanitizeAndRenderLinks(input) {
    const linkRegex = /<a\s+href=["'](.*?)["']>(.*?)<\/a>/gi;
    const container = document.createElement("div");

    let lastIndex = 0;
    let result = "";

    input.replace(linkRegex, (match, href, text, offset) => {
      result += document.createTextNode(
        input.slice(lastIndex, offset)
      ).textContent;

      const a = document.createElement("a");
      a.href = href;
      a.textContent = text;
      a.target = "_self";
      a.rel = "noopener noreferrer";

      const tempDiv = document.createElement("div");
      tempDiv.appendChild(a);
      result += tempDiv.innerHTML;

      lastIndex = offset + match.length;
    });

    result += document.createTextNode(input.slice(lastIndex)).textContent;

    return result;
  }
})();